import FieldDefs from './KeysByLostPageFieldDefs'
import {doLangFields, isGoogleGny} from '../../lib/ks-tools'
import KeysByLostPageGny from "./KeysByLostPageGny";

export default {
    template: `<div><slot v-bind="self"/></div>`,
    data() {
        return {
            fields: doLangFields(this, "lang.report.keysbypage", isGoogleGny() ? KeysByLostPageGny : FieldDefs),
            sortOrder: [
                {
                    field: 'pos',
                    direction: 'asc'
                },
                {
                    field: isGoogleGny() ? 'ws' : 'wsk',
                    direction: 'desc'
                },
            ],
            additionalActions: [
            ]
        }
    },
    computed: {
        self() {
            return this;
        },
    },
}
